module.exports = __webpack_public_path__ + "img/08-bg.64c6d817.jpg";